export default "__VITE_ASSET__HrpZopqW__"